// utils.js
export const formatLeagueName = (leagueName) => {
    if (leagueName === 'PremierLeague') {
        return 'Premier League';
    }
    return leagueName;
};

// Dynamic favicon and title utilities
export const changeFavicon = (iconPath) => {
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = iconPath;
    document.getElementsByTagName('head')[0].appendChild(link);
};

export const changeTitle = (title) => {
    document.title = title;
};

export const setRodmanFavicon = () => {
    changeFavicon('/rodman_favicon.jpg');
    changeTitle('RODMAN AI');
};

export const setDefaultFavicon = () => {
    changeFavicon('/favicon.ico');
    changeTitle('Open Score');
};
